/**
 * Central registry of feature gate keys used in the application.
 * Add new feature gate keys here as string constants.
 */
export const featureGateKeys = {
  /**
   * PAU_CONTEXTUAL_TAGS_BETA
   * @link https://switcheroo.atlassian.com/ui/gates/40c3b4b3-4572-49cb-9572-f41a4038194a/key/pau_contextual_tags_beta
   * @description Controls visibility of AI-generated Contextual tags.
   * OFF by default while Contextual tags remain in beta.
   */
  contextualTagsBeta: 'pau_contextual_tags_beta',
  /**
   * @deprecated A fake gate key used only in unit tests to exercise the fg() utility.
   * Not a real Switcheroo gate — do not use in production code.
   */
  testOnly: 'test-gate-for-unit-tests',
} as const;

export type FeatureGateValue =
  (typeof featureGateKeys)[keyof typeof featureGateKeys];
